<template>
  <div>
    <div>
      <div class="searchbox">
        <form action="#" method="get" class="form-inline form-float">
          <div class="form-group">
            <label for="a_name">物业：</label>
            <el-select
              class="check-property"
              filterable
              clearable
              v-model.trim="search.propertyId"
            >
              <el-option
                v-for="item in propertyList"
                :key="item.id"
                :label="item.name"
                :value="item.id"
              ></el-option>
            </el-select>
          </div>
          <div class="form-group">
            <label for>车牌号:</label>
            <input
              clearable
              v-model.trim="search.carNumber"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group">
            <label for>手机号:</label>
            <input
              clearable
              v-model.trim="search.userPhone"
              class="form-control"
              id
              type="text"
              placeholder
              size="12"
            />
          </div>
          <div class="form-group others">
            <span class="search_btn">
              <button
                @click="searchList"
                type="button"
                class="btn btn-primary"
                id="search_btn"
              >
                查询
              </button>
            </span>
            <!--<button @click="clearSearch" type="button" class="btn btn-default">清空</button>-->
            <span class="add_btn">
              <button
                @click="addrOrEdit()"
                type="button"
                class="btn btn-default"
                id="addarea"
              >
                添加
              </button>
            </span>
            <!-- <span class='refresh_btn'><Refresh @tableList="this.tableList"></Refresh></span> -->
          </div>
          <div class="form-group others">
            <button
              @click="downloadData"
              type="button"
              class="btn btn-primary"
              id="search_btn"
            >
              导出
            </button>
          </div>
        </form>
      </div>
      <div class="list-right">
        <el-table
          ref="table"
          border
          :data="tableListData"
          height="100%"
          :header-cell-style="tableHeaderStyle"
          :cell-style="styleObj"
        >
          <el-table-column
            show-overflow-tooltip
            label="物业"
            prop="propertyName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车牌号"
            prop="carNumber"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="车主"
            prop="userName"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="手机号"
            prop="userPhone"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="总免费时长(小时)"
            prop="totalReductTime"
          ></el-table-column>
          <el-table-column
            show-overflow-tooltip
            label="剩余免费时长(小时)"
            prop="remainReductTime"
          ></el-table-column>
          <el-table-column show-overflow-tooltip label="操作" width="200px">
            <template slot-scope="scope">
              <button
                class="edit"
                type="button"
                @click="onFreeDetailBtn(scope.row)"
              >
                免费记录
              </button>
              <button
                class="edit"
                type="button"
                @click="addrOrEdit(scope.row.plaId)"
              >
                修改
              </button>
              <button
                class="delete"
                type="button"
                @click="del(scope.row.plaId)"
              >
                删除
              </button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <Page v-on:pagination="receivePaginationData" v-bind:pageObj="pageObj"></Page>

    <!-- 添加或编辑 -->
    <el-dialog
      title="添加/编辑白名单"
      :close-on-click-modal="false"
      :lock-scroll="false"
      :visible.sync="dialogFormVisible"
      width="430px"
      @close="closeDialog"
    >
      <el-form
        ref="form"
        label-position="right"
        :model="form"
        :rules="rules"
        :label-width="formLabelWidth"
        id="form"
      >
        <el-form-item label="物业" prop="propertyId">
          <el-select
            class="check-property"
            filterable
            clearable
            v-model.trim="form.propertyId"
          >
            <el-option
              v-for="item in propertyList"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="车牌号" prop="carNumber">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.carNumber"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="车主" prop="userName">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.userName"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="手机号" prop="userPhone">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.userPhone"></el-input>
          </el-col>
        </el-form-item>
        <el-form-item label="免费时长" prop="totalReductTime">
          <el-col :span="18">
            <el-input clearable v-model.trim="form.totalReductTime"></el-input>
          </el-col>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="addrOrEditTrue()">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { mapState, mapMutations, mapGetters } from "vuex";

import {
  updateOneWhite,
  oneWhite,
  getWhiteList,
  addUser,
  getAllRole,
  addManager,
  getManagerSingle,
  delRole,
  fetchPropertyList,

} from "@/api/url";

import Page from "../../commons/page";

import AreaTree from "../../commons/areaTree";

export default {
  name:'white-list',
  data() {
    return {
      styleObj: {
        "text-align": "center",
      },
      tableHeaderStyle: {
        "text-align": "center",
        background: "#F9F9FB",
      },
      propertyList: [],
      moduleName: "parking",
      manager_btn_edit: false,
      manager_btn_delete: false,
      search: {
        pageNumber: 1,
        pageSize: 10,
        carNumber: "",
        userName: "",
        userPhone: "",
        propertyId: null,
      },
      tableListData: [],
      formLabelWidth: "100px",
      dialogFormVisible: false,
      allScopes: {},
      allGroups: {},
      form: {
        id: "",
        name: "",
        carNumber: "",
        userName: "",
        userPhone: "",
        propertyId: null,
        totalReductTime:0
      },
      rules: {
        propertyId: [
          {
            required: true,
            message: "请选择物业",
            trigger: ["blur", "change"],
          },
        ],
        carNumber: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (
                  /^(([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z](([0-9]{5}[DF])|([DF]([A-HJ-NP-Z0-9])[0-9]{4})))|([京津沪渝冀豫云辽黑湘皖鲁新苏浙赣鄂桂甘晋蒙陕吉闽贵粤青藏川宁琼使领][A-Z][A-HJ-NP-Z0-9]{4}[A-HJ-NP-Z0-9挂学警港澳使领]))$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("车牌号输入有误"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写车牌号"));
              }
            },
          },
        ],
        userName: [
          {
            required: true,
            trigger: "blur",
            message: "请输入车主",
          },
        ],
        userPhone: [
          {
            required: true,
            trigger: "blur",
            validator: (rule, value, callback) => {
              // console.log(rule,value);
              if (value != "") {
                if (
                  /^(13[0-9]|14[579]|15[0-3,5-9]|16[6]|17[0135678]|18[0-9]|19[89])\d{8}$/.test(
                    value
                  ) == false
                ) {
                  callback(new Error("请填写正确手机号"));
                } else {
                  callback();
                }
              } else {
                callback(new Error("请填写手机号"));
              }
            },
          },
        ],
      },
      pageObj:{}
    };
  },
  methods: {
    ...mapMutations(["getPage", "storageScenId"]),
    receivePaginationData(v1, v2) {
      this.search.pageNumber = v1;
      this.search.pageSize = v2;
      this.tableList(this.search.pageNumber);
    },
    tableList: function (curPage) {
      var _this = this;
      const { carNumber, userPhone, propertyId, pageSize } = this.search;
      this.$get(getWhiteList(), {
        carNumber: carNumber ? carNumber : null,
        userPhone: userPhone ? userPhone : null,
        limit: pageSize,
        parentId: propertyId ? propertyId : null,
        page: curPage,
      }).then((data) => {
        if (data.status != 200) return _this.$layer.msg(data.message);
        //翻页
        var pageObj = {
          curIndex: data.data.offset,
          rowsCount: data.data.total,
        };
        this.pageObj={...pageObj}
        // _this.getPage(pageObj);
        const {
          data: { rows },
        } = data;
        _this.tableListData = (rows ?? []).map((item) => {
          if (item.parentId && typeof JSON.parse(item.parentId) === "object") {
            item.propertyName = JSON.parse(item.parentId).name;
          }
          return item;
        });
        this.$nextTick(() => {
          this.$refs.table.doLayout();
        });
      });
    },
    searchList: function () {
      this.search.pageNumber = "1";
      this.tableList(this.search.pageNumber);
    },
    clearSearch: function () {
      this.search.pageNumber = "1";
      this.search.userName = "";
    },

    closeDialog: function () {
      this.$refs["form"].resetFields();
    },
    addrOrEdit: function (id) {
      var _this = this;
      this.dialogFormVisible = true;
      if (Boolean(id)) {
        this.form.id = id;
        this.$get(oneWhite() + "/" + id).then((data) => {
          if (data.status != 200) return;
          this.form.carNumber = data.data.carNumber;
          this.form.userName = data.data.userName;
          this.form.userPhone = data.data.userPhone;
          this.form.propertyId = data.data.parentId;
          this.form.totalReductTime=data.data.totalReductTime;
        });
      } else {
        this.form.id = "";
        this.form.carNumber = "";
        this.form.userName = "";
        this.form.userPhone = "";
        this.form.propertyId = null;
        this.form.totalReductTime=0;
      }
    },
    addrOrEditTrue: function () {
      var _this = this;
      this.$refs["form"].validate(function (valid, noStri) {
        if (valid) {
          _this.dialogFormVisible = false;

          if (!Boolean(_this.form.id)) {
            _this
              .$postRequest(oneWhite(), {
                carNumber: _this.form.carNumber,
                userName: _this.form.userName,
                userPhone: _this.form.userPhone,
                parentId: _this.form.propertyId,
                totalReductTime: _this.form.totalReductTime,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "添加成功！",
                });
                _this.search.pageNumber = 1;
                _this.search.carNumber = "";
                _this.search.userPhone = "";
                _this.tableList(_this.search.pageNumber);
              });
          } else {
            _this
              .$putRequest(oneWhite() + "/" + _this.form.id, {
                plaId: _this.form.id,
                carNumber: _this.form.carNumber,
                userName: _this.form.userName,
                userPhone: _this.form.userPhone,
                parentId: _this.form.propertyId,
                totalReductTime: _this.form.totalReductTime,
              })
              .then((data) => {
                if (data.status != 200) return _this.$layer.msg(data.message);
                _this.$notify({
                  type: "success",
                  title: "成功",
                  message: "修改成功！",
                });
                _this.tableList(_this.pageObj.curIndex);
              });
          }
        }
      });
    },
    del: function (id) {
      var _this = this;
      var index = _this.$layer.confirm(
        "您确定删除该车辆信息？",
        {
          btn: ["确定", "取消"],
          shade: true,
        },
        function () {
          _this.$layer.close(index);
          _this.$deleteRequest(oneWhite() + "/" + id).then((data) => {
            if (data.status != 200)
              return _this.$layer.msg("删除失败", { time: 1 });
            _this.$notify({
              type: "success",
              title: "成功",
              message: "删除成功！",
            });
            _this.tableList(_this.pageObj.curIndex);
          });
        }
      );
    },
    getAllProperty() {
      this.$get(fetchPropertyList()).then((data) => {
        if (data.status === 200) {
          this.propertyList = data.data;
        }
      });
    },
    downloadData() {
      const { carNumber, userPhone, propertyId } = this.search;
      this.$downloadFileRequest(
        "/api/parking/plateFree/plateFreeExport",
        {
          carNumber: carNumber ? carNumber : null,
          userPhone: userPhone ? userPhone : null,
          parentId: propertyId ? propertyId : null,
        },
        "vip车辆"
      );
    },
    onFreeDetailBtn(row){
      this.$router.push({
        path:'/main/vehicleManagement/free/free-time-detail',
        query:{record:JSON.stringify(row)}
      })
    }
  },
  computed: {
    ...mapState({
      curIndex: (state) => state.page.curIndex,
      rowsCount: (state) => state.page.rowsCount,
    }),
    ...mapGetters(["elements"]),
    permiss() {
      this.manager_btn_edit = this.elements["manager:btn_edit"];
      this.manager_btn_delete = this.elements["manager:btn_delete"];
    },
  },
  components: {
    Page,
    AreaTree,
  },
  created: function () {
    this.permiss;
  },
  mounted: function () {
    this.getAllProperty();
    this.tableList(this.search.pageNumber);
  },
  watch: {
    elements: {
      handler: function (val, oldVal) {
        this.permiss;
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
</style>